import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

const Draggable = ({
  id, children = null,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
  } = useDraggable({ id });
  const style = {
    transform: CSS.Translate.toString(transform),
  };

  return (
    <div ref={setNodeRef} style={{ margin: 10, ...style }} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

Draggable.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authorId: PropTypes.number.isRequired,
  authorName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Draggable;
